import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function KeyValueEditor({ value, onChange, maxEntries = 50, }) {
    const entries = Object.entries(value);
    function update(idx, key, val) {
        const next = entries.map(([k, v], i) => (i === idx ? [key, val] : [k, v]));
        onChange(Object.fromEntries(next));
    }
    function remove(idx) {
        onChange(Object.fromEntries(entries.filter((_, i) => i !== idx)));
    }
    function add() {
        if (entries.length >= maxEntries)
            return;
        onChange({ ...value, "": "" });
    }
    return (_jsxs("div", { className: "flex flex-col gap-2", children: [entries.map(([k, v], i) => (_jsxs("div", { className: "flex gap-2", children: [_jsx("input", { className: "h-8 flex-1 rounded-sm border border-ink-200 px-2 text-body-sm", placeholder: "Key", value: k, onChange: (e) => update(i, e.target.value, v) }), _jsx("input", { className: "h-8 flex-1 rounded-sm border border-ink-200 px-2 text-body-sm", placeholder: "Value", value: v, onChange: (e) => update(i, k, e.target.value) }), _jsx("button", { type: "button", onClick: () => remove(i), className: "text-danger", "aria-label": "Remove row", children: "\u2715" })] }, i))), _jsx("button", { type: "button", onClick: add, className: "self-start text-caption text-accent", children: "+ Add row" })] }));
}
